import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SpriteSvg } from 'project/sprite-svg';

const defaultState = {
    isActive: false,
    suggestionsIsVisible: false,
    suggestionsToShow: [],
    termsArr: [],
    originalTerm: ''
};

const MIN_TERM_LENGTH = 2;

class SearchAutocomplete extends React.Component {
    constructor(props) {
        super(props);
        this.state = defaultState;
        this.inputRef = React.createRef();
    }

    handleOptionClick = (event, callback) => {
        event.preventDefault();
        this.setState({ suggestionsIsVisible: false });
        callback();
    }

    handleEnter = (event, callback) => {
        if ((event && event.key === 'Enter')) {
            this.setState({ suggestionsIsVisible: false });
            callback(this.state.termsArr);
        }
    }

    searchHandler = (event) => {
        const rawTerm = event.target.value.trim().toLowerCase();
        const terms = rawTerm.split(/\s+/);
        const filteredSuggestionsList = this.props.suggestions.filter((item) => {
            let isMatch = true;
            let itemMatchingMap = {}
            terms.forEach((term) => {
                itemMatchingMap[term] = item.term.toLowerCase().includes(term);
            });

            Object.keys(itemMatchingMap).forEach(key => {
                isMatch = isMatch && itemMatchingMap[key];
            });

            return isMatch;
        });

        this.setState({
            suggestionsToShow: filteredSuggestionsList,
            suggestionsIsVisible: rawTerm.length >= MIN_TERM_LENGTH,
            termsArr: terms,
            originalTerm: event.target.value
        });
    }

    renderIcon() {
        const name = this.state.isActive ? 'cross' : 'search';
        const size = this.state.isActive ? 10 : 14;

        return <SpriteSvg
            childCss="search-autocomplete__icon"
            iconName={name}
            width={size}
            height={size}
        />;
    }

    toggleView = () => {
        const isActive = !this.state.isActive;

        if (isActive) {
            this.setState({ isActive });
            // wait for is-active class
            setTimeout(() => this.inputRef.current.focus(), 50);
        } else {
            this.setState(defaultState, () => {
                this.props.defaultCallback(this.state.termsArr);
            });
        }

        this.props.onToggleState(isActive);
    };

    renderSuggestions = () => {
        if (this.state.suggestionsToShow) {
            return this.state.suggestionsToShow.map((item) => {
                return (
                    <li
                        key={item.id}
                        className="search-autocomplete__suggestions-item"
                    >
                        <div
                            className="search-autocomplete__suggestions-link"
                            onClick={(event) => this.handleOptionClick(event, item.callbackFunc, true)}
                        >
                            {item.suggestionComp()}
                        </div>
                    </li>
                );
            });
        }

        return null;
    };

    renderNoResult = () => {
        if (!this.state.suggestionsToShow.length) {
            return (
                <div className='search-autocomplete__suggestions-link'>No results found!</div>
            );
        }
        return null;
    };

    render() {
        const { defaultCallback } = this.props;

        const stateCss = classNames({
            'is-active': this.state.isActive
        });
        const suggestionsCss = classNames({
            'is-visible': this.state.suggestionsIsVisible
        });

        return (
            <div className={`search-autocomplete ${stateCss}`}>
                <div className="search-autocomplete__container">
                    <input
                        className="search-autocomplete__input"
                        type="text"
                        value={this.state.originalTerm}
                        placeholder="Player name or nationality"
                        ref={this.inputRef}
                        onChange={(event) => this.searchHandler(event)}
                        onKeyPress={(event) => this.handleEnter(event, defaultCallback)}
                    />
                    <button
                        className="search-autocomplete__button"
                        type="button"
                        onClick={() => this.toggleView()}
                    >
                        {this.renderIcon()}
                    </button>
                </div>

                <div className={`search-autocomplete__suggestions ${suggestionsCss} scrollbar`}>
                    <ul className="search-autocomplete__suggestions-list">
                        {this.renderNoResult()}
                        {this.renderSuggestions()}
                    </ul>
                </div>
            </div>
        );
    }
}

SearchAutocomplete.defaultProps = {
    onToggleState: () => {}
};

SearchAutocomplete.propTypes = {
    onToggleState: PropTypes.func,
};

export default SearchAutocomplete;
